import React from 'react'
import _ from 'lodash'
import { Tooltip, Typography } from 'antd';
import { EmojiMap } from './emoji-list';
import AttachmentPreviewBox from 'components/AttachmentPreviewBox';
import { transformLookForCodeSnippet } from 'components/CodeSnippet';
import htmlToMarkDown from './htmlToMarkDownUtil';


export function transformComment(reactNode, node, index, users) {
    const code = transformLookForCodeSnippet(node, index);
    if(code){
        return code;
    }
    // if(["style", "script", "input", "button", "textarea", "meta", "link", "head", "title"].includes(node.name)){
    //     return null;
    // }
    if (node.type === 'tag' && node.name === 'span') {
        if (node.attribs.class === 'emoji') {
            const data = node.children?.[0]?.data;
            if (_.isString(data) && data.startsWith(':') && data.endsWith(':') && EmojiMap[data]) {
                const code_decimal = EmojiMap[data].code_decimal;
                return <span key={code_decimal} dangerouslySetInnerHTML={{ __html: code_decimal }} />;
            }
        } else if (node.attribs.class === 'mention') {
            const data = node.children?.[0]?.data;
            if (_.isString(data) && data.startsWith('@')) {
                return renderMention(node, users);
            }
        }
    } else if(node.type === 'tag' && node.name === 'div' && node.attribs['data-type'] === 'attachment'){
        return <AttachmentPreviewBox name={node.children[0].data} href={node.attribs['data-url'] || node.attribs.href} />
    } else if(node.type === 'tag' && node.name === 'div' && _.includes(node.attribs.class, 'ql-attachment')){
        return <AttachmentPreviewBox name={node.attribs['data-name']} href={node.attribs['data-url']} />
    }

    return reactNode;
}

export function removeAttrs(_dom){
    _.each(_dom.attributes, (attr) => {
        if(attr?.name){
            _dom.removeAttribute(attr.name);
        }
    })
    for(const i in _dom.dataset){
        if(_dom.dataset[i]){
            _dom.removeAttribute(`data-${i}`);
        }
    }
}

export function antiTransformComment(htmlString) {
    const div = document.createElement('div');
    div.innerHTML = htmlString;
    const emojiElements = div.querySelectorAll('.emoji');
    _.each(emojiElements, (elem) => {
        elem.classList.add('ql-emojiblot');
        const emojiName = elem.innerHTML;
        const emojiCode = EmojiMap[emojiName].code_decimal;
        elem.innerHTML = emojiCode;
    });
    
    const mentionElements = div.querySelectorAll('.mention');
    _.each(mentionElements, (elem) => {
        const mentionName = elem.innerHTML.substr(1);
        elem.setAttribute('data-value', mentionName);
        elem.setAttribute('data-denotation-char', '@');
    });
    return div.innerHTML;
}

function renderMention(node, users) {
    const userId = node.attribs['data-id'];
    if (userId) {
        const user = _.find(users, { id: +userId });
        if (user) {
            return (
                <Tooltip title={user.email} key={userId}>
                    <Typography.Link>@{user.displayName}</Typography.Link>
                </Tooltip>
            )
        }
    }
}

export const processHtmlCommentBeforeSubmit = (htmlString) => {
    const _htmlDoc = document.createElement('div');
    _htmlDoc.innerHTML = htmlString;

    // parsing emojis
    const emojis = _htmlDoc.querySelectorAll('.ql-emojiblot');
    _.each(emojis, (emojiDom) => {
        emojiDom.innerHTML = `:${emojiDom.getAttribute('data-name')}:`;
        removeAttrs(emojiDom);
        emojiDom.setAttribute('class', 'emoji');
    });
    //

    // parsing mentions
    const mentions = _htmlDoc.querySelectorAll('.mention');
    _.each(mentions, (mentionDom) => {
        mentionDom.innerHTML = `@${mentionDom.getAttribute('data-value')}`;
        const id = mentionDom.getAttribute('data-id');
        removeAttrs(mentionDom);
        mentionDom.setAttribute('data-id', id);
        mentionDom.setAttribute('class', 'mention');
    });
    // 
    const updatedHtml = _htmlDoc.innerHTML;
    
    return updatedHtml;
}


export const convertHtmlCommentToMarkDown = (htmlString) => {
    const endigTagsToParse = ['p', 'li'];
    endigTagsToParse.forEach(tag => {
        htmlString = htmlString.replaceAll(`</${tag}>`, `</${tag}>\n`);
    });
    
    const tagsToReplace = ['span'];
    tagsToReplace.forEach(tag => {
        htmlString = htmlString.replaceAll(new RegExp(`<${tag} (.*?)>`, 'g'), '');
        htmlString = htmlString.replaceAll(`</${tag}>`, '');
    });
    return htmlToMarkDown(htmlString);
}

export const getMentionUserIds = (htmlString) => {
    const _htmlDoc = document.createElement('div');
    _htmlDoc.innerHTML = htmlString;
    const mentions = _htmlDoc.querySelectorAll('.mention');
    const userIds = [];
    _.each(mentions, (mentionDom) => {
        if(mentionDom.dataset.id){
            userIds.push(mentionDom.dataset.id);
        }
    })
    return userIds;
}